import React from 'react';
import { useNavigate } from 'react-router';
import { useAlert } from 'contexts/AlertContext';
import { Header } from 'components/common/header/Header';
import { BottomNavigation } from 'components/common/bottomNavigation/BottomNavigation';
import './Settings.css';

export const Settings: React.FC = () => {
    const navigate = useNavigate();
    const { showConfirm } = useAlert();

    const handleLogout = async () => {
        // TODO: 로그아웃 로직 구현
        const confirmed = await showConfirm({ message: '로그아웃 하시겠습니까?' });
        if (confirmed) {
            navigate('/login');
        }
    };

    return (
        <div className="settings-wrapper">
            <Header title="설정" isSubPage={true} />

            <div className="settings-content">
                {/* 알림 및 관리 섹션 */}
                <div className="settings-section">
                    <button className="settings-item" onClick={() => navigate('/settings/notifications')}>
                        <span className="settings-item-icon">🔔</span>
                        <span className="settings-item-label">알림 설정</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                    <button className="settings-item" onClick={() => navigate('/settings/blocked-users')}>
                        <span className="settings-item-icon">🚫</span>
                        <span className="settings-item-label">채팅 차단 관리</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                </div>

                {/* 계정 섹션 */}
                <div className="settings-section">
                    <button className="settings-item" onClick={() => navigate('/settings/profile')}>
                        <span className="settings-item-icon">👤</span>
                        <span className="settings-item-label">프로필 설정</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                </div>

                {/* 지원 섹션 */}
                <div className="settings-section">
                    <button className="settings-item" onClick={() => navigate('/settings/notice')}>
                        <span className="settings-item-icon">📢</span>
                        <span className="settings-item-label">공지사항</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                    <button className="settings-item" onClick={() => navigate('/settings/faq')}>
                        <span className="settings-item-icon">❓</span>
                        <span className="settings-item-label">자주 묻는 질문 (FAQ)</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                    <button className="settings-item" onClick={() => navigate('/settings/inquiry')}>
                        <span className="settings-item-icon">✉️</span>
                        <span className="settings-item-label">1:1 문의하기</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                    <button className="settings-item" onClick={() => navigate('/settings/inquiry-list')}>
                        <span className="settings-item-icon">📋</span>
                        <span className="settings-item-label">문의 내역</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                    <button className="settings-item" onClick={() => navigate('/settings/terms')}>
                        <span className="settings-item-icon">📄</span>
                        <span className="settings-item-label">이용약관</span>
                        <span className="settings-item-arrow">›</span>
                    </button>
                </div>

                {/* 로그아웃 */}
                <div className="settings-section">
                    <button className="settings-item logout" onClick={handleLogout}>
                        <span className="settings-item-label">로그아웃</span>
                        <span className="settings-item-arrow">↗</span>
                    </button>
                </div>

                {/* 버전 정보 */}
                <div className="settings-version">
                    현재 버전 1.0.0
                </div>
            </div>

            <BottomNavigation />
        </div>
    );
};
